/**
 * Reusable stateless form component for Answer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import { TextInput } from '../../../global/components/forms';

function AnswerForm({
  cancelLink
  , formTitle
  , formType
  , handleFormChange
  , handleFormSubmit
  , answer
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create Answer" : "Update Answer";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="answerForm" className="answer-form" onSubmit={handleFormSubmit}>
            {header}
            <TextInput
              change={handleFormChange}
              label="Name"
              name="name"
              placeholder="Name (required)"
              required={true}
              value={answer.name}
            />
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > {buttonText} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

AnswerForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , answer: PropTypes.object.isRequired
}

AnswerForm.defaultProps = {
  formTitle: ''
}

export default AnswerForm;



// WEBPACK FOOTER //
// modules/answer/components/AnswerForm.js.jsx